interface HomeGreetingProps {
  greeting: string;
  pendingCount: number;
}

export function HomeGreeting({ greeting, pendingCount }: HomeGreetingProps) {
  return (
    <div className="home-greeting-area">
      <h1 className="home-greeting">{greeting}</h1>
      {pendingCount > 0 && (
        <p className="home-pending-count">
          {pendingCount} item{pendingCount !== 1 ? 's' : ''} waiting for you
        </p>
      )}
    </div>
  );
}
